import { render, staticRenderFns } from "./AbsenceChip.vue?vue&type=template&id=1df5e04e"
import script from "./AbsenceChip.vue?vue&type=script&lang=js"
export * from "./AbsenceChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports